import { createSelector } from 'reselect';
import { dashboardListSelector } from '@store/tempDashboard/selectors';
import { selectors as sharedTabsSelector } from '@store/sharedTabs';
import { compareTabsSelector } from '@store/dashboards/tabs/selectors';

export const tabsListSelector = createSelector(
  dashboardListSelector,
  compareTabsSelector,
  sharedTabsSelector,
  (dashboardList, compareTabs, { tabs: sharedTabs = [] }) => {
    if ( dashboardList.length > 0 || compareTabs.length > 0 || sharedTabs.length > 0 ) {
      return true;
    }
    return false;
  }
);
